export const footerTranslations = {
    en: { copyright: "Talend, Inc., All Rights Reserved" },
    "en-GB": { copyright: "Talend, Inc., All Rights Reserved" },
    de: { copyright: "Talend, Inc., Alle Rechte vorbehalten." },
    fr: { copyright: "Talend, Inc., Tous droits réservés." },
    it: { copyright: "Talend, Inc., Tutti i diritti riservati." },
    ja: { copyright: "Talend, Inc., All Rights Reserved" },
};
